import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';
import colors from '../../_foundations/colors.json';
import Icon from '../Icon';
import Text from '../Text';
import buttonColors from './color.json';

export const ButtonContainer = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${Text} {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${Text},
  ${Icon} {
    color: currentcolor;
  }

  ${({ buttonType, buttonStyle, size, disabled }) => {
    let height = 40;
    let textSize = 200;
    let padding = '0.5rem';
    const borderRadius = '0.5rem';
    let gap = '0.5rem';

    const color =
      colors[buttonColors[buttonStyle][buttonType].color] || colors.neutral900;
    const backgroundColor =
      colors[buttonColors[buttonStyle][buttonType].background] || 'transparent';
    const backgroundColorHover =
      colors[buttonColors[buttonStyle][buttonType]['background-hover']] ||
      'transparent';
    const backgroundColorActive =
      colors[buttonColors[buttonStyle][buttonType]['background-active']] ||
      'transparent';
    const borderColor =
      colors[buttonColors[buttonStyle][buttonType]['border-color']];

    const cursorType = disabled ? 'not-allowed' : 'pointer';

    if (size === 'sm') {
      textSize = 100;
      height = 28;
      padding = '0.25rem 0.5rem';
      gap = '0.25rem';
    }

    return css`
      height: ${height}px;
      min-width: ${height}px;
      line-height: ${height}px;
      padding: ${padding};
      gap: ${gap};
      ${mixin.text({ size: textSize, strong: true })}
      border-radius: ${borderRadius};
      background-color: ${backgroundColor};
      color: ${color};
      cursor: ${cursorType};

      ${borderColor &&
      css`
        border: 2px solid ${borderColor};
      `}

      ${Text} {
        ${mixin.text({ size: textSize, strong: true })}
      }

      &:hover {
        background-color: ${backgroundColorHover};
        color: ${color};
        text-decoration: none;
      }

      &:active {
        background-color: ${backgroundColorActive};
        color: ${color};
      }

      ${disabled &&
      css`
        opacity: 0.5;
        &:hover {
          background-color: ${backgroundColor} !important;
        }
      `}
    `;
  }}
`;
